import React, { useEffect, useState } from 'react';
import styles from "./Home.module.scss";
import $api, { API_URL } from "../../../api/instance";
import errorMessage from "../../../const/Tost";

const Home = () => {
    const [data, setData] = useState(null);
    const initialLoadCount = 5;
    const [visibleRows, setVisibleRows] = useState(new Array(4).fill(initialLoadCount));
    const [expanded, setExpanded] = useState(new Set());
    const [serchParems, setSerchParems] = useState({
        registered: '',
        labTechnician: '',
        doctor: '',
        finished: ''
    });

    useEffect(() => {
        const getDirectionsByStatus = async () => {
            try {
                const params = new URLSearchParams({
                    withAssociates: 'true',
                    ...(serchParems.registered && { registered: serchParems.registered }),
                    ...(serchParems.labTechnician && { labTechnician: serchParems.labTechnician }),
                    ...(serchParems.doctor && { doctor: serchParems.doctor }),
                    ...(serchParems.finished && { finished: serchParems.finished }),
                });

                const response = await $api.get(`${API_URL}/direction/by-status?${params.toString()}`);
                if (response?.data) {
                    setData(response.data);
                }
            } catch (error) {
                errorMessage(error, error?.response?.data?.message);
            }
        };

        getDirectionsByStatus();
    }, [serchParems]);

    const loadMore = (index) => {
        setVisibleRows((prevState) => {
            const newState = [...prevState];
            newState[index] += initialLoadCount;
            return newState;
        });
    };

    const toggleExpand = (id) => {
        setExpanded((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(id)) {
                newSet.delete(id);
            } else {
                newSet.add(id);
            }
            return newSet;
        });
    };

    const handleSearchChange = (type, value) => {
        setSerchParems((prev) => ({
            ...prev,
            [type]: value
        }));
    };

    const renderTable = (title, items = [], index, type) => (
        <div className={styles['home-page__wrapper']} key={type}>
            <table>
                <thead>
                <tr>
                    <th>{title}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                        <input
                            style={{ width: '98%' }}
                            type="text"
                            value={serchParems[type] || ''}
                            onChange={(e) => handleSearchChange(type, e.target.value)}
                        />
                    </td>
                </tr>
                {items?.slice(0, visibleRows[index]).map((referral, i) => (
                    <tr key={referral.id || i}>
                        <td>
                            <div className={styles['record-container']}>
                                <p>Скерування №{referral?.id}</p>
                                <p>Лікар {referral?.activeDoc}</p>
                                <p>Дата: {referral?.operationDate?.split('T')[0]}</p>
                                {referral?.patient?.lastName && referral?.patient?.name && (
                                    <p>
                                        Пацієнт: {referral?.patient?.lastName} {referral?.patient?.name} {referral?.patient?.middleName}
                                    </p>
                                )}
                                {expanded.has(referral?.id) && (
                                    <p>Дослідження: {referral?.clinicalInfo}</p>
                                )}
                                <button onClick={() => toggleExpand(referral?.id)}>
                                    {expanded.has(referral?.id) ? 'Сховати опис' : 'Показати опис'}
                                </button>
                            </div>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
            <div className={styles['btn__wrapper']}>
                {visibleRows[index] < (items?.length || 0) && (
                    <button onClick={() => loadMore(index)}>Завантажити ще</button>
                )}
            </div>
        </div>
    );

    return (
        <div className={styles['table__container']}>
            {renderTable("Зареєстровані скерування", data?.registered, 0, 'registered')}
            {renderTable("Лабораторні дослідження", data?.labTechnician, 1, 'labTechnician')}
            {renderTable("Передані до лікаря", data?.doctor, 2, 'doctor')}
            {renderTable("Виконані скерування", data?.finished, 3, 'finished')}
        </div>
    );
};

export default Home;
